import React, { useEffect, useState } from "react";
import s from "../PremiosPagados.module.css";

//assets
import gamesService from "../../../../api/games/GamesService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material Ui
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import "dayjs/locale/pt";

const FiltrosPremiosPagados = ({
  searching,
  handleSearch,
  handleCleanFilters,
  dateType,
  setDateType,
  filters,
  setFilters,
  setLoadingFilters,
  games,
  setGames,
}) => {
  const { t } = useTranslation();

  const organization = useSelector((state) => state.gamma.activeOrganization);
  const { language } = useSelector((state) => state.local);

  useEffect(() => {
    if (!games.length) {
      setLoadingFilters(true);
      gamesService.getAllGames().then((res) => {
        setGames(res.content);
        setLoadingFilters(false);
      });
    }
  }, []);

  let dates = [
    {
      type: 1,
      item: (
        <MenuItem value={1} key={1}>
          {t("drawDate")}
        </MenuItem>
      ),
    },
    {
      type: 1,
      item: (
        <MenuItem value={2} key={2}>
          {t("dateOfExpiry")}
        </MenuItem>
      ),
    },
    {
      type: 1,
      item: (
        <MenuItem value={3} key={3}>
          {t("paymentDate")}
        </MenuItem>
      ),
    },
    {
      type: 2,
      item: (
        <MenuItem value={4} key={4}>
          {t("uploadDate")}
        </MenuItem>
      ),
    },
  ];

  return (
    <Grid item container xs={11} className={s.filters}>
      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
        <FormControl fullWidth>
          <InputLabel id="label-select">{`${t("type")} de ${t("game")}`}</InputLabel>
          <Select
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                type: e.target.value,
                gameId: 0,
                dateFrom: null,
                dateTo: null,
              }));
              setDateType(0);
            }}
            value={filters.type}
            labelId="label-select"
            label={`${t("type")} de ${t("game")}`}
            sx={{ width: "90%" }}
          >
            <MenuItem value={0}>{t("all")}</MenuItem>
            <MenuItem value={1}>{t("preprinted")}</MenuItem>
            <MenuItem value={2}>{t("instant")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
        <FormControl fullWidth>
          <InputLabel id="label-select-game">{t("game")}</InputLabel>
          <Select
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, gameId: e.target.value }))
            }
            value={filters.gameId}
            disabled={filters.type === 0}
            labelId="label-select-game"
            label={t("game")}
            sx={{ width: "90%" }}
          >
            <MenuItem value={0}>{t("all")}</MenuItem>
            {games.map((item, i) => {
              return item.modality.mode.id === filters.type ? (
                <MenuItem key={i} value={item.modality?.game?.id}>
                  {item.modality?.game?.name}
                </MenuItem>
              ) : null;
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init3]}>
        <FormControl fullWidth>
          <InputLabel id="label-select-agency">{`${t("type")} de ${t("agency")}`}</InputLabel>
          <Select
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, typeAgency: e.target.value }))
            }
            value={filters.typeAgency}
            labelId="label-select-agency"
            label={`${t("type")} de ${t("agency")}`}
            sx={{ width: "90%" }}
          >
            <MenuItem value={0}>{t("all")}</MenuItem>
            <MenuItem value={1}>{t("sellingAgency")}</MenuItem>
            <MenuItem value={2}>{t("payingAgency")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {filters?.typeAgency ? (
        <>
          <Grid
            item
            container
            xs={11}
            md={5}
            lg={3}
            className={[s.init2]}
            sx={{
              mb: "30px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid item xs={6}>
              <TextField
                value={filters.agencyFrom}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setFilters((prev) => ({
                      ...prev,
                      agencyFrom: Number(e.target.value),
                    }));
                  }
                }}
                label={t("from")}
                sx={{ width: "90%" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={filters.agencyTo}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setFilters((prev) => ({
                      ...prev,
                      agencyTo: Number(e.target.value),
                    }));
                  }
                }}
                label={t("to")}
                sx={{ width: "90%" }}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid item xs={11} md={5} lg={3} />
      )}

      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
        <FormControl sx={{ width: "90%" }}>
          <InputLabel
            id={"select-label"}
          >{`${t("type")} de ${t("date")}`}</InputLabel>
          <Select
            labelId="select-label"
            label={`${t("type")} de ${t("date")}`}
            value={dateType}
            onChange={(e) => {
              if (e.target.value === 0) {
                setDateType(e.target.value);
                setFilters((prev) => ({
                  ...prev,
                  dateTo: null,
                  dateFrom: null,
                }));
              } else {
                setDateType(e.target.value);
              }
            }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            {dates.map((date) => {
              return filters.type === 0 || date.type === filters.type
                ? date.item
                : null;
            })}
          </Select>
        </FormControl>
      </Grid>

      {!dateType ? null : (
        <>
          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={language}
            >
              <DatePicker
                label={!!filters?.dateFrom ? `${t("from")} X` : t("from")}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, dateFrom: e }))
                }
                inputFormat="DD/MM/YYYY"
                clearable
                value={filters.dateFrom || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{ width: "90%" }}
                    InputLabelProps={{
                      onClick: () =>
                        setFilters((prev) => ({ ...prev, dateFrom: null })),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={language}
            >
              <DatePicker
                label={!!filters?.dateTo ? `${t("to")} X` : t("to")}
                onChange={(e) => setFilters((prev) => ({ ...prev, dateTo: e }))}
                inputFormat="DD/MM/YYYY"
                clearable
                value={filters.dateTo || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{ width: "90%" }}
                    InputLabelProps={{
                      onClick: () =>
                        setFilters((prev) => ({ ...prev, dateTo: null })),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </>
      )}
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Button onClick={handleSearch} variant="contained">
          {t("consult")}
        </Button>
        {searching ? (
          <Button
            onClick={handleCleanFilters}
            variant="contained"
            sx={{ ml: 1 }}
          >
            {t("clearFilters")}
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default FiltrosPremiosPagados;
